import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { Toaster } from 'sonner';
import { initMetaPixel } from "./lib/metaPixel";

// Build tag (used to verify a fresh deploy bundle is being served).
// Bump this string to force the deploy pipeline to detect a frontend
// source-tree change and run a clean `yarn build`.
const BUILD_TAG = "jp-frontend-2026-10-29-d12-shell-4g";
if (typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.log("[JP] frontend build tag:", BUILD_TAG);
}

// W-6: the white-screen failure mode is a PARSE failure — it happens before
// any module code runs at all. So if a single line of this module executes,
// the bundle has already loaded and parsed successfully; module execution is
// the proof, not the render call. Run this ABOVE initMetaPixel() so the very
// first PageView reports the cleaned URL: signal the app-shell recovery
// (public/boot-recovery.js) to clear its guard flag and scrub the cache-buster
// param off the URL, so analytics and shared links never carry it. Keep the
// window.__jpBootRecovery guard so a missing recovery script can't crash boot.
if (typeof window !== "undefined" && window.__jpBootRecovery) {
  window.__jpBootRecovery.onBooted();
}

const rootEl = document.getElementById("root");
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// D12: Ensure the static HTML pre-JS shell is removed once React mounts,
// and defer Meta Pixel initialization until after first paint so nothing
// third-party executes before first paint.
if (typeof window !== "undefined" && typeof document !== "undefined") {
  window.requestAnimationFrame(() => {
    const shell = document.getElementById("jp-app-shell");
    if (shell && shell.parentNode) {
      shell.parentNode.removeChild(shell);
    }
    setTimeout(() => {
      initMetaPixel();
    }, 0);
  });
}
